import { StateCreator } from 'zustand'
import { Store } from '../type'

type AuthSlice = Pick<
  Store,
  'resendActivationEmail' | 'isResendingActivationEmail'
>

export const authSlice: StateCreator<Store, [], [], AuthSlice> = (
  set,
  get,
) => ({
  isResendingActivationEmail: false,
  resendActivationEmail: async (email) => {
    const { brand, lang } = get()

    set({ isResendingActivationEmail: true })
    const response = await fetch(
      `/auth/api/resend-confirmation-link-route?lang=${lang}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-awaze-brand': `${brand}`,
        },
        body: JSON.stringify({ email }),
      },
    )
    set({ isResendingActivationEmail: false })

    return response
  },
})
